import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { showErrorPopup, translateError } from "@components/ErrorHandling";

export function useWindowSize() {
  const isClient = typeof window === "object";

  const [windowSize, setWindowSize] = useState({
    width: isClient ? window.innerWidth : undefined,
    height: isClient ? window.innerHeight : undefined,
  });

  useEffect(() => {
    const isClient = typeof window === "object";

    if (!isClient) {
      return false;
    }

    function handleResize() {
      setWindowSize({
        width: isClient ? window.innerWidth : undefined,
        height: isClient ? window.innerHeight : undefined,
      });
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return windowSize;
}

export function sendEvent(event, payload) {
  const data = {
    event: {
      ident: event,
      payload: payload || null,
    },
  };

  let tokenUUID = "";

  if (localStorage.getItem("token")) {
    tokenUUID = localStorage.getItem("token");
  }

  fetch(import.meta.env.VITE_API_URL + "/consumer/event", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${tokenUUID}`,
    },
    body: JSON.stringify(data),
  })
    .then((response) => {
      return response.json();
    })
    .then(
      (result) => {},
      (error) => {
        console.log(error);
      },
    );
}

export function leadingZero(day) {
  let d = parseInt(day);
  if (d < 10) {
    return "0" + d;
  } else {
    return "" + d;
  }
}

export function parseDate(d, hours, showSeconds, addDays) {
  let date;
  try {
    date = new Date(d.replace(" ", "T"));
  } catch (error) {
    return "n/d";
  }
  let seconds = ":" + leadingZero(date.getSeconds());

  if (showSeconds === false) {
    seconds = "";
  }

  if (addDays) {
    date.setDate(date.getDate() + addDays);
  }

  if (hours) {
    return (
      leadingZero(date.getDate()) +
      "/" +
      leadingZero(date.getMonth() + 1) +
      "/" +
      date.getFullYear() +
      ", " +
      leadingZero(date.getHours()) +
      ":" +
      leadingZero(date.getMinutes()) +
      seconds
    );
  } else {
    return (
      leadingZero(date.getDate()) +
      "." +
      leadingZero(date.getMonth() + 1) +
      "." +
      date.getFullYear()
    );
  }
}

export function validateDates(vlalidTo, serverTime, daysAdded = 0) {
  const date1 = new Date(vlalidTo);
  date1.setDate(date1.getDate() + daysAdded);
  const date2 = new Date(serverTime);

  return date1 <= date2;
}

export function localeString(string) {
  const date = new Date(string);
  return date.toLocaleDateString("pl-PL", {
    day: "numeric",
    month: "long",
    year: "numeric",
  });
}

export function validToBreakpoint(
  created,
  validToFromServer,
  disabledValidation = false,
  serverTime = null,
  forceChcek = false,
) {
  let date = new Date(created);
  const magicDate = new Date("2022-03-15 00:00");

  if (date < magicDate) {
    return disabledValidation
      ? validateDates(validToFromServer, serverTime)
      : parseDate(validToFromServer);
  }

  if (forceChcek) {
    return disabledValidation
      ? validateDates(validToFromServer, serverTime)
      : parseDate(validToFromServer);
  }

  return disabledValidation
    ? validateDates(created, serverTime, 30)
    : parseDate(created, false, false, 30);
}

export function getCookie(sName) {
  var oCrumbles = document.cookie.split(";");
  for (var i = 0; i < oCrumbles.length; i++) {
    var oPair = oCrumbles[i].split("=");
    var sKey = decodeURIComponent(oPair[0].trim());
    var sValue = oPair.length > 1 ? oPair[1] : false;
    if (sKey === sName) {
      return decodeURIComponent(sValue);
    }
  }
  return undefined;
}

export function setCookie(sName, sValue, options) {
  var sCookie = encodeURIComponent(sName) + "=" + encodeURIComponent(sValue);
  if (options && options instanceof Date) {
    options = {
      expires: options,
    };
  }
  if (options && typeof options === "object") {
    if (options.expires) {
      sCookie += "; expires=" + options.expires.toGMTString();
    }
    if (options.path) {
      sCookie += "; path=" + options.path.toString();
    }
    if (options.domain) {
      sCookie += "; domain=" + options.domain.toString();
    }
    if (options.secure) {
      sCookie += "; secure";
    }
    if (options.sameSite) {
      sCookie += "; SameSite=" + options.sameSite.toString();
    }
  }
  document.cookie = sCookie;
}

export function removeCookie(sName) {
  const cookie = `${sName}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;domain=${
    import.meta.env.VITE_BRANCH === "dev"
      ? location.hostname === "localhost"
        ? "localhost"
        : ".amplifyapp.com"
      : ".inspirationclub.pl"
  };SameSite=Lax;Secure`;
  document.cookie = cookie;
}

export function sendFloodEvent(sendTo, path) {
  if (window.gtag) {
    window.gtag(
      "event",
      "conversion",
      path
        ? {
            allow_custom_scripts: true,
            u1: path,
            send_to: sendTo,
          }
        : {
            allow_custom_scripts: true,
            send_to: sendTo,
          },
    );
  }
}

export function debounce(func, timeout = 300) {
  let timer;
  return function (...args) {
    const context = this;
    if (timer) clearTimeout(timer);
    timer = setTimeout(() => {
      timer = null;
      func.apply(context, args);
    }, timeout);
  };
}

const BLOCKED_KEYS = new Set(["__proto__", "prototype", "constructor"]);

export function getModuleValue(modulesArray, type, field) {
  if (!modulesArray || modulesArray.length === 0 || typeof field !== "string") {
    return;
  }

  const root = modulesArray.find((obj) => obj?.type === type);
  if (root == null) {
    return;
  }

  return field.split(".").reduce((current, key) => {
    if (
      current == null ||
      BLOCKED_KEYS.has(key) ||
      !Object.prototype.hasOwnProperty.call(current, key)
    ) {
      return undefined;
    }
    return current[key];
  }, root);
}

export function parseHTMLToText(html, HTMLTag, toArray = false) {
  let text = "";
  let dummy = document.createElement("html");
  dummy.innerHTML = html;
  let lenght = dummy.getElementsByTagName(HTMLTag).length;
  let finalArray = [];
  for (let i = 0; i < lenght; i++) {
    if (toArray) {
      finalArray.push(dummy.getElementsByTagName(HTMLTag).item(i).innerHTML);
    } else {
      text += dummy.getElementsByTagName(HTMLTag).item(i).innerHTML;
      text += " ";
    }
  }
  return toArray ? finalArray : text;
}

export function checkToken() {
  const token = localStorage.getItem("token");

  if (!token) {
    return false;
  }

  // const parsedToken = JSON.parse(token)
  // const tokenDate = new Date(parsedToken?.expires)
  // const currentDate = new Date()

  // if (!!tokenDate || (currentDate > tokenDate)) {
  //   // expired token or invalid token date
  //   return false
  // }

  return true;
}

export async function fetchData({
  endpoint,
  method = "POST",
  payload,
  form = false,
  successCallback,
  errorCallback = false,
  fetchErrorCallback = false,
  shouldThrowError = true,
  setLoading = false,
  controller = false,
  m2Token = false,
} = {}) {
  let resObj;
  let tokenUUID = "";
  const urlSearchParams = new URLSearchParams(window.location.search);
  const tokenFromURL = urlSearchParams.get("token");

  if (m2Token) {
    tokenUUID = m2Token;
  } else if (tokenFromURL) {
    tokenUUID = tokenFromURL;
  } else if (localStorage.getItem("token")) {
    tokenUUID = localStorage.getItem("token");
  }

  if (setLoading) {
    setLoading(true);
  }

  try {
    const headers = {
      Authorization: `Bearer ${tokenUUID}`,
    };

    if (!form) {
      headers["Content-Type"] = "application/json";
    }

    const response = await fetch(import.meta.env.VITE_API_URL + endpoint, {
      method: method,
      headers,
      body: form || JSON.stringify(payload),
      ...(controller && {
        signal: controller.signal,
      }),
    });

    if (response.status === 401) {
      removeCookie("ICToken");
      localStorage.removeItem("token");
      localStorage.removeItem("loginEvent");
      localStorage.removeItem("urlParams");
      localStorage.removeItem("identify");
      sessionStorage.removeItem("passportData");
      sessionStorage.removeItem("halloween2025_start");
      sessionStorage.removeItem("hideEasterEggBar");
      sessionStorage.removeItem("foundEggs");
      sessionStorage.removeItem("sId");
      sessionStorage.removeItem("loginSource");
      window.location.href = "/logout";
      return;
    }

    resObj = await response.json();

    if (resObj.status.success) {
      if (successCallback) successCallback(resObj);
    } else {
      if (errorCallback) {
        errorCallback(resObj);
      }
      if (shouldThrowError) {
        showErrorPopup(
          translateError(resObj.data.error, resObj.meta.id),
          resObj.meta.ts,
        );
      }
    }
  } catch (error) {
    if (fetchErrorCallback) {
      fetchErrorCallback(error);
    }
    if (shouldThrowError) {
      showErrorPopup(
        translateError(resObj.data.error, resObj.meta.id),
        resObj.meta.ts,
      );
    }
  } finally {
    if (setLoading) {
      setLoading(false);
    }
  }

  return resObj?.data;
}

export const useCountdown = (targetDate) => {
  const countDownDate = new Date(targetDate).getTime();

  const [countDown, setCountDown] = useState(
    countDownDate - new Date().getTime(),
  );

  useEffect(() => {
    const interval = setInterval(() => {
      setCountDown(countDownDate - new Date().getTime());
    }, 1000);

    return () => clearInterval(interval);
  }, [countDownDate]);

  return getReturnValues(countDown);
};

const getReturnValues = (countDown) => {
  // calculate time left
  if (countDown <= 0) {
    return [0, 0, 0, 0];
  }

  const days = Math.floor(countDown / (1000 * 60 * 60 * 24));
  const hours = Math.floor(
    (countDown % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60),
  );
  const minutes = Math.floor((countDown % (1000 * 60 * 60)) / (1000 * 60));
  const seconds = Math.floor((countDown % (1000 * 60)) / 1000);

  return [days, hours, minutes, seconds];
};

export function useSessionStorage(key, initialValue) {
  const [storedValue, setStoredValue] = useState(() => {
    if (window)
      try {
        const item = window.sessionStorage.getItem(key);
        return item ? JSON.parse(item) : initialValue;
      } catch (error) {
        console.log(error);
        return initialValue;
      }
  });
  if (typeof window === "undefined") {
    return initialValue;
  }
  const setValue = (value) => {
    try {
      const valueToStore =
        value instanceof Function ? value(storedValue) : value;
      setStoredValue(valueToStore);
      window.sessionStorage.setItem(key, JSON.stringify(valueToStore));
      window.dispatchEvent(new Event("storage"));
    } catch (error) {
      console.log(error);
    }
  };
  return [storedValue, setValue];
}

export function useLocalStorage(key, initialValue) {
  const [storedValue, setStoredValue] = useState(() => {
    if (window)
      try {
        const item = window.localStorage.getItem(key);
        return item ? JSON.parse(item) : initialValue;
      } catch (error) {
        console.log(error);
        return initialValue;
      }
  });
  if (typeof window === "undefined") {
    return initialValue;
  }
  const setValue = (value) => {
    try {
      const valueToStore =
        value instanceof Function ? value(storedValue) : value;
      setStoredValue(valueToStore);
      window.localStorage.setItem(key, JSON.stringify(valueToStore));
    } catch (error) {
      console.log(error);
    }
  };
  return [storedValue, setValue];
}

export const stringToStrong = (text, string) => {
  if (!text.includes(string) || string.length < 2) {
    return text;
  } else {
    return text.replaceAll(string, "<strong>" + string + "</strong>");
  }
};

export const boldQuery = (str, query) => {
  const n = str.toUpperCase();
  const q = query.toUpperCase();
  const x = n.indexOf(q);
  if (!q || x === -1) {
    return str; // bail early
  }
  const l = q.length;
  return (
    str.substr(0, x) + "<b>" + str.substr(x, l) + "</b>" + str.substr(x + l)
  );
};

export const useScrollToTop = () => {
  const excludedPaths = ["/poznaj-produkty/"];
  const { pathname } = useLocation();
  useEffect(() => {
    if (!pathname.includes(excludedPaths)) {
      window.scrollTo(0, 0);
    }
  }, [pathname]);
};

export function resolveCmsUrl(url) {
  if (!url) {
    return false;
  }

  if (typeof url === "boolean") {
    return url;
  }

  if (typeof url === "string") {
    return url.trim() || false;
  }

  if (Array.isArray(url)) {
    return resolveCmsUrl(url[0]);
  }

  if (typeof url === "object") {
    const candidate = url.custom ?? url.url ?? url.path ?? url.href;
    return resolveCmsUrl(candidate);
  }

  return false;
}

export function getNotificationTarget(notify) {
  if (notify?.coupon?.uuid) {
    return `/coupons/received/${notify.coupon.uuid}`;
  }

  if (notify?.prize?.uuid) {
    return `/prize/redeem/${notify.prize.uuid}`;
  }

  return resolveCmsUrl(notify?.url);
}

export function openAppLink(url, navigate) {
  if (typeof url !== "string" || !url) {
    return;
  }

  const isAbsolute = url.startsWith("http://") || url.startsWith("https://");

  if (!isAbsolute) {
    navigate(url.startsWith("/") ? url : `/${url}`);
    return;
  }

  try {
    const parsed = new URL(url);

    if (parsed.origin === window.location.origin) {
      navigate(`${parsed.pathname}${parsed.search}${parsed.hash}`);
      return;
    }
  } catch {
    // fall through to external open
  }

  window.open(url, "_blank", "noopener,noreferrer");
}

export function parseCMSBold(string, specialChar = "*") {
  let output = "";
  let insideStrongTag = false;

  for (let i = 0; i < string?.length; i++) {
    const currentChar = string[i];
    const nextChar = string[i + 1];

    if (currentChar === specialChar) {
      if (insideStrongTag) {
        output += "</strong>";
        insideStrongTag = false;
      } else {
        output += "<strong>";
        insideStrongTag = true;
      }
    } else {
      output += currentChar;
    }

    if (insideStrongTag && nextChar === undefined) {
      output += "</strong>";
      insideStrongTag = false;
    }
  }

  return output;
}

export const getStoreLink = (onlineStoreName = "") => {
  if (onlineStoreName.includes("velo")) {
    return `${import.meta.env.VITE_VUSE_URL}`;
  } else {
    return `${import.meta.env.VITE_DG_URL}`;
  }
};

export const onlineBadge = (stores = []) => {
  if (stores?.length > 0) {
    const onlineStores = ["sklep_online", "sklep_velo", "sklep-glo"];
    const storesHaveOnlineStore = onlineStores.some((onlineStore) =>
      stores.includes(onlineStore),
    );
    return storesHaveOnlineStore;
  } else {
    return false;
  }
};

export function isCouponInStock(coupon) {
  return coupon?.inStock || !!coupon?.activation;
}

const COUPON_AVAILABILITY = {
  0: { label: "Ausverkauft", progress: 0 },
  1: { label: "Niedrig", progress: 1 / 3 },
  2: { label: "Mittel", progress: 2 / 3 },
  3: { label: "Hoch", progress: 1 },
};

export function getCouponAvailability(level) {
  if (level === null || level === undefined || level === "") return null;
  return COUPON_AVAILABILITY[level] ?? null;
}

export function getCouponAvailabilityLabel(level) {
  return getCouponAvailability(level)?.label ?? null;
}

export function isCouponSoldOut(level) {
  return level === 0 || level === "0";
}

export function isCouponPlaceholder(ident) {
  return typeof ident === "string" && ident.includes("_placeholder");
}

export function shouldRedirectCouponToActivation(coupon) {
  if (getCouponRaffleOutroType(coupon)) {
    return false;
  }

  return (
    isCouponPlaceholder(coupon?.ident) &&
    !!coupon?.activation &&
    !coupon.activation.completed &&
    !coupon.activation.expired
  );
}

export function getCouponRaffleOutroType(coupon) {
  if (!isCouponPlaceholder(coupon?.ident)) {
    return null;
  }

  const modules = coupon?.content?.modules;

  if (getModuleValue(modules, "raffle_outro_fail", "custom")) {
    return "fail";
  }

  if (
    coupon?.activation?.completed === true &&
    getModuleValue(modules, "raffle_outro_pending", "custom")
  ) {
    return "pending";
  }

  return null;
}

export function isCouponRaffleOutro(coupon) {
  return getCouponRaffleOutroType(coupon) !== null;
}

export function isCouponRafflePending(coupon) {
  return isCouponRaffleOutro(coupon);
}

export function getCouponRaffleOutroContent(coupon) {
  const type = getCouponRaffleOutroType(coupon);

  if (type === "fail") {
    return getModuleValue(
      coupon?.content?.modules,
      "raffle_outro_fail",
      "custom",
    );
  }

  if (type === "pending") {
    return getModuleValue(
      coupon?.content?.modules,
      "raffle_outro_pending",
      "custom",
    );
  }

  return null;
}

export function getCouponRaffleOutroSectionTitle(type) {
  if (type === "fail") {
    return "Lieben Dank, dass du dabei bist!";
  }

  if (type === "pending") {
    return "Du bist dabei!";
  }

  return null;
}

export function isContestActivation({ ident, type } = {}) {
  if (type === "Contest") return true;
  return typeof ident === "string" && ident.startsWith("contest_");
}

export function getActivationActivityPath(activation) {
  if (!activation?.ident) return "/activities";
  if (isContestActivation(activation)) {
    return `/contest/${activation.ident}`;
  }
  return `/activities/${activation.ident}`;
}

export function isGameRewardIdent(ident) {
  return typeof ident === "string" && ident.includes("_gamereward");
}

export function toGameRewardIdent(placeholderIdent) {
  if (!isCouponPlaceholder(placeholderIdent)) return null;
  return placeholderIdent.replace("_placeholder", "_gamereward");
}

export function findGameRewardPrizeInList(prizes, placeholderIdent) {
  const gameRewardIdent = toGameRewardIdent(placeholderIdent);
  if (!gameRewardIdent) return null;

  return (
    (prizes || []).find((prize) => prize?.catalogue?.ident === gameRewardIdent) ??
    null
  );
}

export function invalidateCouponRedeemQueries(queryClient) {
  queryClient.invalidateQueries({ queryKey: ["coupon-catalogue-describe"] });
  queryClient.invalidateQueries({
    queryKey: ["coupon-catalogue-ultrainsider-describe"],
  });
  queryClient.invalidateQueries({ queryKey: ["prize-ultra-insider"] });
  queryClient.invalidateQueries({ queryKey: ["prize-list"] });
  queryClient.invalidateQueries({ queryKey: ["coupon-ultra-insider"] });
}

export function getGameRewardPrizeRedeemPath(prize, { ultraInsider = false } = {}) {
  if (!prize) return null;

  if (ultraInsider && prize.catalogue?.ident) {
    return `/coupons/ultra-insider/redeem/${prize.catalogue.ident}`;
  }

  if (prize.uuid) {
    return `/prize/redeem/${prize.uuid}`;
  }

  return null;
}

export function filterGameRewardCatalogue(catalogue) {
  return (catalogue || []).filter((item) => !isGameRewardIdent(item?.ident));
}

export function filterGameRewardPrizes(prizes) {
  return (prizes || []).filter(
    (prize) => !isGameRewardIdent(prize?.catalogue?.ident),
  );
}

export function filterGameRewardCoupons(coupons) {
  return (coupons || []).filter(
    (coupon) => !isGameRewardIdent(coupon?.catalogue?.ident),
  );
}

export function withFilteredCatalogue(result) {
  if (!result?.catalogue) return result;
  const catalogue = filterGameRewardCatalogue(result.catalogue);
  return { ...result, catalogue, count: catalogue.length };
}

export function withFilteredPrizes(result) {
  if (!result?.prizes) return result;
  const prizes = filterGameRewardPrizes(result.prizes);
  return { ...result, prizes };
}

export function withFilteredCoupons(result) {
  if (!result?.coupon) return result;
  const coupon = filterGameRewardCoupons(result.coupon);
  return { ...result, coupon };
}

// QR scanner survey is Vuse-only: show it when the consumer has no brands yet
// (empty array) or has opted into "vuse"; hide it for glo-only consumers.
export function canAccessQrScanner(brands) {
  if (!brands || brands.length === 0) return true;
  return brands.includes("vuse");
}

export function applySortCouponsRules(data) {
  if (!data) return [];
  const deepCopyOfData = JSON.parse(
    JSON.stringify(filterGameRewardCatalogue(data)),
  );

  return deepCopyOfData.sort((a, b) => {
    if (a.hasLevel !== b.hasLevel) {
      return a.hasLevel ? -1 : 1;
    }
    if (a.hasPoints !== b.hasPoints) {
      return a.hasPoints ? -1 : 1;
    }
    if (isCouponSoldOut(a.availabilityLevel) !== isCouponSoldOut(b.availabilityLevel)) {
      return isCouponSoldOut(a.availabilityLevel) ? 1 : -1;
    }
    if (isCouponInStock(a) !== isCouponInStock(b)) {
      return isCouponInStock(a) ? -1 : 1;
    }

    return b.priority - a.priority;
  });
}

const DJ_CONSOLE_BY_REGISTER_SOURCE = {
  discoverglode: "tml2026_dj_console_glo",
  vusede: "tml2026_dj_console_vuse",
};

const DJ_CONSOLE_IDENTS = [
  "tml2026_dj_console_glo",
  "tml2026_dj_console_vuse",
];

export function filterDjConsoleActivations(activations, registerSource) {
  if (!activations?.length || !registerSource) return activations;

  const allowedIdent = DJ_CONSOLE_BY_REGISTER_SOURCE[registerSource];
  if (!allowedIdent) return activations;

  return activations.filter(
    (activation) =>
      !DJ_CONSOLE_IDENTS.includes(activation.ident) ||
      activation.ident === allowedIdent,
  );
}

const ULTRA_SPACE_ONLY_BANNER_IDENTS = [
  "vuse-tle-us-only",
  "vuse-enter-us-only",
];

const ULTRA_SPACE_EXCLUDED_BANNER_IDENTS = ["vuse-tle-us-excluded"];

export function filterUltraSpaceBanners(sliders, ultraInsider) {
  if (!sliders?.length) return sliders;

  return sliders.filter((slide) => {
    if (ULTRA_SPACE_ONLY_BANNER_IDENTS.includes(slide.ident)) {
      return ultraInsider;
    }
    if (ULTRA_SPACE_EXCLUDED_BANNER_IDENTS.includes(slide.ident)) {
      return !ultraInsider;
    }
    return true;
  });
}

const ULTRA_SPACE_ONLY_STORY_IDENTS = [
  "vuse-tle",
  "vuse-ultra-refresh",
  "vuse-skaner-promo",
  "vuse-skaner-instrukcja",
];

export function filterUltraSpaceStories(stories, ultraInsider) {
  if (!stories?.length) return stories;

  return stories.filter((story) => {
    if (ULTRA_SPACE_ONLY_STORY_IDENTS.includes(story.ident)) {
      return ultraInsider;
    }
    return true;
  });
}
